import type { TItemType } from '@modules/items';

export const SEARCH_ENDPOINT = '/search';

export const SEARCH_QUERY_KEY = 'search';

// Mirrors backend/src/search/configs/search.config.ts.
export const SEARCHABLE_ITEM_TYPES: readonly TItemType[] = [
  'DOCUMENT',
  'FILE',
  'INLINE_BLOCK',
  'REPLICA_DOCUMENT',
  'REPLICA_FILE',
];

export const MAX_SEARCH_DROPDOWN_SIZE = 7;

export const MIN_SEARCH_QUERY_LENGTH = 2;

export const UI_MARGIN_TOP = 150;

export const SEARCH_BLOCKS_CONDITION = {
  ALL: 'ALL',
  EXCLUSIVELY: 'EXCLUSIVELY',
  NO: 'NO',
} as const;

export type TSearchBlocksCondition = (typeof SEARCH_BLOCKS_CONDITION)[keyof typeof SEARCH_BLOCKS_CONDITION];

// Mirrors SearchTemplatesCondition in backend/src/search/configs/search.config.ts.
export const SEARCH_TEMPLATES_CONDITION = {
  ALL: 'ALL',
  EXCLUSIVELY: 'EXCLUSIVELY',
} as const;

export type TSearchTemplatesCondition = (typeof SEARCH_TEMPLATES_CONDITION)[keyof typeof SEARCH_TEMPLATES_CONDITION];
